export const preventEventPropagation = (e) => {
  e?.preventDefault();
  e?.stopPropagation();
};

export const isInteractiveElement = (target) => {
  if (!target) return false;
  return (
    target?.closest(".control") ||
    target?.closest(".play-button") ||
    target?.tagName === "BUTTON" ||
    target?.tagName === "SVG" ||
    target?.closest("svg") ||
    target?.closest(".preview-overlay") ||
    target?.closest(".preview-footer")
  );
};

export const getClientCoordinates = (e) => {
  if (e?.touches && e?.touches?.length > 0) {
    return {
      clientX: e?.touches[0]?.clientX,
      clientY: e?.touches[0]?.clientY,
    };
  }
  return {
    clientX: e?.clientX,
    clientY: e?.clientY,
  };
};

export const postSize = ({minimized, isFullScreenPlayer}) => {
  const styles = {
    common: {
      width: "150px",
      height: "200px",
      backgroundColor:"rgba(255, 255, 255, 0.1)",
      border:" 1px dashed rgba(0, 0, 0, 0.1)",
      "min-width": "150px",
      "min-height": "200px",
      display:"block",
      visibility:"visible",
      "z-index":1050,
    },
    position: {},
  };
  if (minimized) {
    styles.common.width = "100px";
    styles.common.height = "100px";
  } else if (isFullScreenPlayer) {
    styles.common.width = window?.innerWidth > 768 ? "40%" : "90%";
    styles.common.height = "90vh";
    styles.common["min-width"] = "300px";
    styles.common["max-width"] = "430px";
    styles.common["max-height"] = "90vh";
  }

  // styles.position.right = "20px";
  // styles.position.bottom = "20px";

  window.parent.postMessage({ type: "IFRAME_SIZE", styles }, "*");
};

export const getIOStyle = ({apiKey=false}={}) => {
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);

  // if (!isIOS) return null;
  const windowHeight = window?.innerHeight || 0;
  return {
    fullScreenPlayer: {
      maxHeight: isIOS
        ? `${windowHeight * 0.95}px`
        : isAndroid
        ? "85vh"
        : apiKey ? "100vh" : "95vh",
      height: isIOS ? `${windowHeight * 0.95}px` : isAndroid ? "85vh" : apiKey ? "100vh" :  "95vh",
      ...(isAndroid
        ? {
            top: "4.5%",
            left: "2.5%",
          }
        : {}),
    },
    fullScreenPlayerPreview: {
      height: isIOS ? `${windowHeight * 0.9}px` : isAndroid ? "80vh" : apiKey ? "100vh" : "90vh",
      maxHeight: isIOS
        ? `${windowHeight * 0.9}px`
        : isAndroid
        ? "80vh"
        : apiKey ? "100vh" : "90vh",
    },
  };
};
